module.exports = __webpack_public_path__ + "img/logo-gtlc.558df291.svg";